// Central multilingual content + data for Zheng Da Abogados (ES / EN / ZH / PT)

export const LANGS = [
  { code: 'es', label: 'Español', short: 'ES' },
  { code: 'en', label: 'English', short: 'EN' },
  { code: 'zh', label: '中文', short: '中文' },
  { code: 'pt', label: 'Português', short: 'PT' },
];

export const CONTACT = {
  email: 'info@zdabogados.es',
  whatsapp: '+34622207888',
  whatsappLink: 'https://wa.me/+34622207888',
  addressLine1: 'C/ Valdeón, 10B, Planta 1',
  addressLine2: '28947 - Fuenlabrada (Madrid)',
  mapsLink:
    'https://maps.google.com/maps?q=Calle+De+Valde%C3%B3n+10%2C+28947+Fuenlabrada%2C+Madrid%2C+Espa%C3%B1a',
  facebook: 'https://www.facebook.com/zhengdaabogados/',
  wechat: 'https://mp.weixin.qq.com/s/rUXu21HciwATvb6qbqZf0g',
  xiaohongshu:
    'https://www.xiaohongshu.com/user/profile/60981d350000000001000c4e',
};

export const IMAGES = {
  heroBg:
    'https://images.unsplash.com/photo-1598139384902-5a8217874645?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000',
  aboutTeam:
    'https://images.unsplash.com/photo-1571055931484-22dce9d6c510?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600',
  consultation:
    'https://images.unsplash.com/photo-1562564055-71e051d33c19?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600',
  director:
    'https://images.unsplash.com/photo-1560250097-0b93528c311a?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200',
  officeWide:
    'https://images.unsplash.com/photo-1662104935883-e9dd0619eaba?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000',
  aboutHero:
    'https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000',
};

export const SERVICES = [
  {
    slug: 'asesoria-contable',
    icon: 'Calculator',
    image:
      'https://images.unsplash.com/photo-1709880945165-d2208c6ad2ec?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400',
    es: {
      title: 'Asesoría Contable',
      short:
        'La contabilidad va más allá de la obligación con la administración. Tener la información adecuada te ayudará a tomar mejores decisiones.',
      long: 'Te ayudamos a interpretar los datos contables con el objetivo de reducir gastos, mejorar la rentabilidad y optimizar tus recursos financieros. Llevamos tu contabilidad al día y te ofrecemos informes claros para que entiendas la situación real de tu empresa en cada momento.',
      points: ['Contabilidad general y analítica', 'Cuentas anuales y libros oficiales', 'Informes financieros y de rentabilidad', 'Análisis y reducción de gastos'],
    },
    en: {
      title: 'Accounting Advisory',
      short:
        'Accounting goes beyond an obligation to the administration. Having the right information helps you make better decisions.',
      long: 'We help you interpret accounting data to reduce costs, improve profitability and optimize your financial resources. We keep your books up to date and provide clear reports so you always understand your company\u2019s real situation.',
      points: ['General and analytical accounting', 'Annual accounts and official books', 'Financial and profitability reports', 'Cost analysis and reduction'],
    },
    zh: {
      title: '会计咨询',
      short: '会计不仅仅是对行政部门的义务。掌握正确的信息将帮助您为企业做出更好的决策。',
      long: '我们帮助您解读会计数据，以降低成本、提高盈利能力并优化财务资源。我们及时处理您的账目，并提供清晰的报告，让您随时了解企业的真实状况。',
      points: ['一般与分析会计', '年度账目与法定账簿', '财务与盈利报告', '成本分析与削减'],
    },
    pt: {
      title: 'Assessoria Contábil',
      short:
        'A contabilidade vai além da obrigação com a administração. Ter a informação correta ajuda você a tomar melhores decisões.',
      long: 'Ajudamos você a interpretar os dados contábeis para reduzir custos, melhorar a rentabilidade e otimizar seus recursos financeiros. Mantemos sua contabilidade em dia e oferecemos relatórios claros para que você entenda a situação real da sua empresa a todo momento.',
      points: ['Contabilidade geral e analítica', 'Contas anuais e livros oficiais', 'Relatórios financeiros e de rentabilidade', 'Análise e redução de custos'],
    },
  },
  {
    slug: 'juridica1',
    icon: 'Scale',
    image:
      'https://images.unsplash.com/photo-1562564055-71e051d33c19?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400',
    es: {
      title: 'Asesoría Jurídica',
      short: 'Asesoramiento jurídico integral para empresas o particulares en cualquier ámbito del derecho.',
      long: 'Ofrecemos asistencia especializada en cualquier ámbito del derecho, así como representación legal y elaboración de informes y documentos jurídicos. Trabajamos tanto a nivel preventivo como en la dirección de procedimientos contenciosos, siempre con rigor y ética profesional.',
      points: ['Derecho civil y mercantil', 'Redacción de contratos e informes', 'Representación legal', 'Asesoramiento preventivo'],
    },
    en: {
      title: 'Legal Advisory',
      short: 'Comprehensive legal advice for companies and individuals in any area of law.',
      long: 'We offer specialized assistance in any area of law, as well as legal representation and the preparation of legal reports and documents. We work both preventively and in the management of litigation, always with rigor and professional ethics.',
      points: ['Civil and commercial law', 'Drafting of contracts and reports', 'Legal representation', 'Preventive advice'],
    },
    zh: {
      title: '法律咨询',
      short: '为企业和个人提供各法律领域的全面法律咨询服务。',
      long: '我们在各个法律领域提供专业协助，包括法律代理以及法律报告和文件的编写。我们既提供预防性咨询，也负责诉讼程序，始终秉持严谨和职业道德。',
      points: ['民法与商法', '合同与报告起草', '法律代理', '预防性咨询'],
    },
    pt: {
      title: 'Assessoria Jurídica',
      short: 'Assessoria jurídica integral para empresas e particulares em qualquer área do direito.',
      long: 'Oferecemos assistência especializada em qualquer área do direito, bem como representação legal e elaboração de relatórios e documentos jurídicos. Atuamos tanto de forma preventiva quanto na condução de processos contenciosos, sempre com rigor e ética profissional.',
      points: ['Direito civil e comercial', 'Redação de contratos e relatórios', 'Representação legal', 'Assessoria preventiva'],
    },
  },
  {
    slug: 'asesoria-mercantil',
    icon: 'Building2',
    image:
      'https://images.pexels.com/photos/7693692/pexels-photo-7693692.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=800&w=1400',
    es: {
      title: 'Asesoría Mercantil',
      short: 'Constituir una empresa ya no es complicado. Somos punto PAE: la gestión es más rápida y económica.',
      long: 'Como Punto PAE facilitamos la constitución de empresas de forma telemática y el alta de autónomos en un plazo máximo de tres días. Te aportamos ideas como establecer un pacto de socios que te dará tranquilidad y solidez a tu proyecto empresarial.',
      points: ['Constitución telemática de empresas', 'Alta de autónomos en 72h', 'Pactos de socios', 'Punto PAE (plataforma CIRCE)'],
    },
    en: {
      title: 'Commercial Advisory',
      short: 'Setting up a company is no longer complicated. We are a PAE point: management is faster and more economical.',
      long: 'As a PAE point we make it easy to set up companies electronically and register self-employed workers within a maximum of three days. We provide ideas such as establishing a partners\u2019 agreement that will give you peace of mind and solidity for your business project.',
      points: ['Electronic company formation', 'Self-employed registration in 72h', 'Partners\u2019 agreements', 'PAE point (CIRCE platform)'],
    },
    zh: {
      title: '商事咨询',
      short: '成立公司不再复杂。我们是 PAE 服务点：办理更快捷、更经济。',
      long: '作为 PAE 服务点，我们提供在线公司注册服务，并可在最多三天内完成自雇人士的注册。我们为您提供诸如签订股东协议等建议，让您的创业项目更加稳固安心。',
      points: ['在线公司注册', '72小时内自雇注册', '股东协议', 'PAE 服务点 (CIRCE 平台)'],
    },
    pt: {
      title: 'Assessoria Comercial',
      short: 'Abrir uma empresa já não é complicado. Somos ponto PAE: a gestão é mais rápida e econômica.',
      long: 'Como ponto PAE, facilitamos a constituição de empresas de forma eletrônica e o registro de autônomos em no máximo três dias. Oferecemos ideias como estabelecer um acordo de sócios que trará tranquilidade e solidez ao seu projeto empresarial.',
      points: ['Constituição eletrônica de empresas', 'Registro de autônomos em 72h', 'Acordos de sócios', 'Ponto PAE (plataforma CIRCE)'],
    },
  },
  {
    slug: 'asesoria-fiscal',
    icon: 'Landmark',
    image:
      'https://images.unsplash.com/photo-1772588627342-5ec373e236d8?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400',
    es: {
      title: 'Asesoría Fiscal',
      short: 'El pago de impuestos es imprescindible. Te ayudamos con una buena planificación fiscal para no pagar de más.',
      long: 'Realizamos una planificación fiscal a medida para que no pagues impuestos de más y cumplas siempre con tus obligaciones. Además te facilitamos una previsión del pago de impuestos para que controles tu tesorería con antelación.',
      points: ['Planificación fiscal a medida', 'Impuestos de sociedades e IRPF', 'Declaraciones de IVA', 'Previsión y control de tesorería'],
    },
    en: {
      title: 'Tax Advisory',
      short: 'Paying taxes is essential. We help you with good tax planning so you don\u2019t pay more than necessary.',
      long: 'We carry out tailored tax planning so you don\u2019t pay more taxes than necessary and always meet your obligations. We also provide a tax payment forecast so you can control your cash flow in advance.',
      points: ['Tailored tax planning', 'Corporate and income tax', 'VAT returns', 'Cash flow forecast and control'],
    },
    zh: {
      title: '税务咨询',
      short: '纳税是必须的。我们通过合理的税务规划帮助您避免多缴税款。',
      long: '我们为您量身定制税务规划，让您避免多缴税款并始终履行纳税义务。此外，我们为您提供纳税预测，帮助您提前掌控资金流。',
      points: ['定制税务规划', '公司税与个人所得税', '增值税申报', '资金预测与管控'],
    },
    pt: {
      title: 'Assessoria Fiscal',
      short: 'Pagar impostos é essencial. Ajudamos você com um bom planejamento fiscal para não pagar a mais.',
      long: 'Realizamos um planejamento fiscal sob medida para que você não pague impostos a mais e cumpra sempre suas obrigações. Além disso, fornecemos uma previsão do pagamento de impostos para que controle seu caixa com antecedência.',
      points: ['Planejamento fiscal sob medida', 'Imposto de renda e de empresas', 'Declarações de IVA', 'Previsão e controle de caixa'],
    },
  },
  {
    slug: 'asesoria-laboral',
    icon: 'Users',
    image:
      'https://images.unsplash.com/photo-1517048676732-d65bc937f952?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400',
    es: {
      title: 'Asesoría Laboral',
      short: 'Lo importante es elegir el contrato y la bonificación más adecuados para evitar costos innecesarios.',
      long: 'Te ayudamos a elegir el contrato laboral y las bonificaciones más adecuadas, incluyendo cláusulas adicionales que salvaguarden a tu empresa y eviten costes futuros y denuncias innecesarias. Gestionamos nóminas, altas, bajas y todos los trámites con la Seguridad Social.',
      points: ['Nóminas y seguros sociales', 'Contratos y bonificaciones', 'Altas y bajas de trabajadores', 'Inspecciones de trabajo'],
    },
    en: {
      title: 'Labor Advisory',
      short: 'The key is choosing the most suitable contract and incentives to avoid unnecessary costs.',
      long: 'We help you choose the most suitable employment contract and incentives, including additional clauses that safeguard your company and avoid future costs and unnecessary claims. We manage payroll, registrations, terminations and all Social Security procedures.',
      points: ['Payroll and social security', 'Contracts and incentives', 'Employee registration and termination', 'Labor inspections'],
    },
    zh: {
      title: '劳动咨询',
      short: '关键在于选择最合适的劳动合同和补贴，以避免不必要的成本。',
      long: '我们帮助您选择最合适的劳动合同和补贴，包括保护企业的附加条款，避免未来成本和不必要的诉讼。我们负责工资单、员工入职离职以及所有社会保障相关手续。',
      points: ['工资单与社会保险', '合同与补贴', '员工入职与离职', '劳动检查'],
    },
    pt: {
      title: 'Assessoria Trabalhista',
      short: 'O importante é escolher o contrato e os incentivos mais adequados para evitar custos desnecessários.',
      long: 'Ajudamos você a escolher o contrato de trabalho e os incentivos mais adequados, incluindo cláusulas adicionais que protegem sua empresa e evitam custos futuros e ações desnecessárias. Gerenciamos folhas de pagamento, admissões, demissões e todos os trâmites com a Previdência Social.',
      points: ['Folha de pagamento e previdência', 'Contratos e incentivos', 'Admissão e demissão de funcionários', 'Inspeções do trabalho'],
    },
  },
  {
    slug: 'gestoria-administrativa',
    icon: 'FileText',
    image:
      'https://images.unsplash.com/photo-1560264280-88b68371db39?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400',
    es: {
      title: 'Gestoría Administrativa',
      short: 'Realizamos gestiones de tráfico, Registro Civil, Ministerio de Justicia y legalización de documentos.',
      long: 'Nos encargamos de todo tipo de gestiones administrativas: trámites de tráfico, Registro Civil, Ministerio de Justicia, legalización y apostilla de documentos, y muchas otras gestiones para ahorrarte tiempo y desplazamientos.',
      points: ['Trámites de tráfico (DGT)', 'Registro Civil', 'Legalización de documentos', 'Apostilla de La Haya'],
    },
    en: {
      title: 'Administrative Management',
      short: 'We handle traffic procedures, Civil Registry, Ministry of Justice and document legalization.',
      long: 'We take care of all kinds of administrative procedures: traffic (DGT) procedures, Civil Registry, Ministry of Justice, document legalization and apostille, and many other procedures to save you time and travel.',
      points: ['Traffic procedures (DGT)', 'Civil Registry', 'Document legalization', 'Hague apostille'],
    },
    zh: {
      title: '行政管理',
      short: '我们办理交通、民事登记、司法部及文件公证等各类手续。',
      long: '我们负责各类行政手续：交通管理局手续、民事登记、司法部事务、文件公证与认证等诸多事务，为您节省时间和往返奔波。',
      points: ['交通管理局手续', '民事登记', '文件公证', '海牙认证'],
    },
    pt: {
      title: 'Gestão Administrativa',
      short: 'Realizamos trâmites de trânsito, Registro Civil, Ministério da Justiça e legalização de documentos.',
      long: 'Cuidamos de todo tipo de trâmites administrativos: procedimentos de trânsito, Registro Civil, Ministério da Justiça, legalização e apostila de documentos e muitos outros trâmites para economizar seu tempo e deslocamentos.',
      points: ['Trâmites de trânsito (DGT)', 'Registro Civil', 'Legalização de documentos', 'Apostila de Haia'],
    },
  },
  {
    slug: 'extranjeria',
    icon: 'Plane',
    image:
      'https://images.unsplash.com/photo-1454496406107-dc34337da8d6?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400',
    es: {
      title: 'Extranjería',
      short: 'Damos solución a todo tipo de servicio en cuanto a extranjería y migración.',
      long: 'Gestionamos todo tipo de trámites de extranjería y migración: permisos de residencia y trabajo, renovaciones, reagrupación familiar, nacionalidad española, arraigo y recursos. Te acompañamos en cada paso del proceso.',
      points: ['Permisos de residencia y trabajo', 'Nacionalidad española', 'Reagrupación familiar', 'Arraigo y renovaciones'],
    },
    en: {
      title: 'Immigration',
      short: 'We provide solutions for all kinds of immigration and migration matters.',
      long: 'We manage all types of immigration and migration procedures: residence and work permits, renewals, family reunification, Spanish nationality, roots (arraigo) and appeals. We accompany you at every step of the process.',
      points: ['Residence and work permits', 'Spanish nationality', 'Family reunification', 'Roots (arraigo) and renewals'],
    },
    zh: {
      title: '移民事务',
      short: '我们为各类外国人事务和移民提供解决方案。',
      long: '我们办理各类外国人事务与移民手续：居留和工作许可、续签、家庭团聚、西班牙国籍、居留证明及行政复议。我们在整个过程中的每一步为您提供协助。',
      points: ['居留与工作许可', '西班牙国籍', '家庭团聚', '居留证明与续签'],
    },
    pt: {
      title: 'Imigração',
      short: 'Oferecemos soluções para todo tipo de assunto de imigração e migração.',
      long: 'Gerenciamos todo tipo de trâmites de imigração e migração: autorizações de residência e trabalho, renovações, reagrupamento familiar, nacionalidade espanhola, arraigo e recursos. Acompanhamos você em cada etapa do processo.',
      points: ['Autorizações de residência e trabalho', 'Nacionalidade espanhola', 'Reagrupamento familiar', 'Arraigo e renovações'],
    },
  },
  {
    slug: 'asesoria-aduanera',
    icon: 'Ship',
    image:
      'https://images.unsplash.com/photo-1603796846097-bee99e4a601f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400',
    es: {
      title: 'Asesoría Aduanera',
      short: 'Servicios relacionados con el despacho de aduanas y la gestión de trámites aduaneros.',
      long: 'Ofrecemos todos los servicios relacionados con el despacho de aduanas, así como la gestión de los trámites aduaneros necesarios para que tus mercancías sean admitidas, tanto a la salida como a la entrada del país.',
      points: ['Despacho de aduanas', 'Importación y exportación', 'Gestión de aranceles', 'Documentación aduanera'],
    },
    en: {
      title: 'Customs Advisory',
      short: 'Services related to customs clearance and the management of customs procedures.',
      long: 'We offer all services related to customs clearance, as well as the management of the necessary customs procedures so that your goods are admitted both when leaving and entering the country.',
      points: ['Customs clearance', 'Import and export', 'Tariff management', 'Customs documentation'],
    },
    zh: {
      title: '海关咨询',
      short: '提供与海关清关及海关手续办理相关的各项服务。',
      long: '我们提供与海关清关相关的所有服务，以及办理必要的海关手续，确保您的货物在出入境时均能顺利通关。',
      points: ['海关清关', '进出口业务', '关税管理', '海关文件'],
    },
    pt: {
      title: 'Assessoria Aduaneira',
      short: 'Serviços relacionados ao despacho aduaneiro e à gestão de trâmites alfandegários.',
      long: 'Oferecemos todos os serviços relacionados ao despacho aduaneiro, bem como a gestão dos trâmites alfandegários necessários para que suas mercadorias sejam admitidas tanto na saída quanto na entrada do país.',
      points: ['Despacho aduaneiro', 'Importação e exportação', 'Gestão de tarifas', 'Documentação aduaneira'],
    },
  },
];

export const PILLARS = [
  {
    icon: 'BadgeCheck',
    es: { title: 'Calidad del servicio', text: 'Todos nuestros profesionales están profundamente comprometidos con la calidad del servicio que prestan.' },
    en: { title: 'Service quality', text: 'All our professionals are deeply committed to the quality of the service they provide.' },
    zh: { title: '服务品质', text: '我们所有的专业人员都深切致力于提供高品质的服务。' },
    pt: { title: 'Qualidade do serviço', text: 'Todos os nossos profissionais estão profundamente comprometidos com a qualidade do serviço que prestam.' },
  },
  {
    icon: 'Layers',
    es: { title: 'Servicio integral', text: 'Prestamos todos los servicios profesionales que tu empresa demanda bajo una perspectiva global.' },
    en: { title: 'Comprehensive service', text: 'We provide all the professional services your company needs from a global perspective.' },
    zh: { title: '一站式服务', text: '我们从全局视角为您的企业提供所需的一切专业服务。' },
    pt: { title: 'Serviço integral', text: 'Prestamos todos os serviços profissionais que sua empresa precisa a partir de uma perspectiva global.' },
  },
  {
    icon: 'Award',
    es: { title: 'Más de 10 años de experiencia', text: 'Llevamos más de una década prestando servicios a un gran colectivo de empresas.' },
    en: { title: 'Over 10 years of experience', text: 'We have been serving a large group of companies for more than a decade.' },
    zh: { title: '十余年经验', text: '我们已为众多企业提供服务超过十年之久。' },
    pt: { title: 'Mais de 10 anos de experiência', text: 'Prestamos serviços a um grande grupo de empresas há mais de uma década.' },
  },
  {
    icon: 'Heart',
    es: { title: 'Alto nivel de satisfacción', text: 'Nuestros clientes muestran un alto nivel de satisfacción, nuestra mayor garantía.' },
    en: { title: 'High level of satisfaction', text: 'Our clients show a high level of satisfaction, our greatest guarantee.' },
    zh: { title: '高满意度', text: '我们的客户满意度极高，这是我们最大的保证。' },
    pt: { title: 'Alto nível de satisfação', text: 'Nossos clientes demonstram um alto nível de satisfação, nossa maior garantia.' },
  },
  {
    icon: 'ShieldCheck',
    es: { title: 'Tranquilidad', text: 'Te explicamos qué hacer y cuándo, con información continua y un lenguaje sencillo.' },
    en: { title: 'Peace of mind', text: 'We explain what to do and when, with continuous information in simple language.' },
    zh: { title: '安心无忧', text: '我们用通俗的语言向您解释该做什么、何时做，并持续提供最新信息。' },
    pt: { title: 'Tranquilidade', text: 'Explicamos o que fazer e quando, com informação contínua e linguagem simples.' },
  },
  {
    icon: 'PiggyBank',
    es: { title: 'Ahorro', text: 'Planificación fiscal y laboral que te ayuda a ahorrar impuestos y evitar costes futuros.' },
    en: { title: 'Savings', text: 'Tax and labor planning that helps you save taxes and avoid future costs.' },
    zh: { title: '节省成本', text: '税务和劳动规划帮助您节省税款并避免未来成本。' },
    pt: { title: 'Economia', text: 'Planejamento fiscal e trabalhista que ajuda você a economizar impostos e evitar custos futuros.' },
  },
];

export const STATS = [
  { value: '10+', es: 'Años de experiencia', en: 'Years of experience', zh: '年经验', pt: 'Anos de experiência' },
  { value: '500+', es: 'Clientes satisfechos', en: 'Satisfied clients', zh: '满意客户', pt: 'Clientes satisfeitos' },
  { value: '8', es: 'Áreas de servicio', en: 'Service areas', zh: '服务领域', pt: 'Áreas de serviço' },
  { value: '4', es: 'Países', en: 'Countries', zh: '国家', pt: 'Países' },
];

export const OFFICES = [
  {
    key: 'cn',
    status: 'active',
    es: { country: 'China', city: 'Oficina de representación' },
    en: { country: 'China', city: 'Representative office' },
    zh: { country: '中国', city: '代表处' },
    pt: { country: 'China', city: 'Escritório de representação' },
  },
  {
    key: 'es',
    status: 'active',
    main: true,
    es: { country: 'España', city: 'Fuenlabrada, Madrid' },
    en: { country: 'Spain', city: 'Fuenlabrada, Madrid' },
    zh: { country: '西班牙', city: '马德里 Fuenlabrada' },
    pt: { country: 'Espanha', city: 'Fuenlabrada, Madri' },
  },
  {
    key: 'mx',
    status: 'active',
    es: { country: 'México', city: 'Lago Alberto 320, Parques Polanco, Piso 2 — Granada, Miguel Hidalgo, 11520 CDMX' },
    en: { country: 'Mexico', city: 'Lago Alberto 320, Parques Polanco, 2nd Floor — Granada, Miguel Hidalgo, 11520 Mexico City' },
    zh: { country: '墨西哥', city: '墨西哥城 Miguel Hidalgo，Lago Alberto 320，Parques Polanco 二楼（邮编 11520）' },
    pt: { country: 'México', city: 'Lago Alberto 320, Parques Polanco, 2º Andar — Granada, Miguel Hidalgo, 11520 Cidade do México' },
  },
  {
    key: 'br',
    status: 'soon',
    es: { country: 'Brasil', city: 'Próxima apertura' },
    en: { country: 'Brazil', city: 'Opening soon' },
    zh: { country: '巴西', city: '即将开业' },
    pt: { country: 'Brasil', city: 'Em breve' },
  },
];

export const translations = {
  es: {
    nav: { home: 'Inicio', about: 'Quiénes Somos', services: 'Servicios', contact: 'Contacto', cta: 'Solicitar consulta' },
    hero: {
      eyebrow: 'Despacho de abogados y asesores',
      title: 'Asesoramiento fiscal, laboral, contable y jurídico',
      subtitle: 'Dirigido a PYMES, autónomos y personas físicas. Un equipo de profesionales altamente cualificados y con gran experiencia al servicio de la comunidad china en España.',
      ctaPrimary: 'Ver todos los servicios',
      ctaSecondary: 'Hablemos',
      scroll: 'Descubre más',
    },
    about: {
      eyebrow: '¿Quiénes somos?',
      title: 'Tu despacho de confianza en España',
      p1: 'Zheng Da Abogados es un despacho que presta servicios de asesoramiento jurídico a nivel empresarial y particular, dirigido principalmente a la comunidad china en España.',
      p2: 'Estamos registrados como Punto PAE (punto de asesoramiento al emprendedor dentro de la plataforma CIRCE). Podemos constituir empresas de forma telemática y dar de alta como autónomo en un intervalo máximo de tres días.',
      p3: 'Nuestros abogados y asesores estarán encantados de poder ayudarte en tus asuntos, siempre desde una relación de transparencia y confianza mutua.',
      readMore: 'Leer más',
      quote: '«El crecimiento de una empresa se basa en el aprovechamiento máximo de sus recursos»',
      quoteAuthor: 'Libo Chen, director de Zheng Da Abogados',
      pageIntro: 'Ofrecemos asesoramiento tanto a nivel preventivo como de dirección contenciosa en las diferentes ramas del derecho, basándonos siempre en una relación de transparencia y confianza mutua. Damos cobertura a toda la geografía nacional de España.',
    },
    pillars: { eyebrow: 'Nuestros', title: 'Pilares de servicio' },
    services: {
      eyebrow: '¿Qué hacemos?',
      title: 'Todos los servicios que necesitas, en un sitio',
      subtitle: 'Un equipo multidisciplinar que cubre todas las necesidades de tu empresa y de tu vida personal.',
      all: 'Ver todos los servicios', detail: 'Ver detalle', backToServices: 'Volver a servicios', relatedTitle: 'Otros servicios', keyPoints: 'Lo que incluye',
    },
    location: { eyebrow: 'Nuestra ubicación', title: 'Zheng Da Abogados Fuenlabrada', directions: 'Cómo llegar' },
    offices: { eyebrow: 'Presencia internacional', title: 'Estamos donde nos necesitas', subtitle: 'Un despacho con vocación global: acompañamos a nuestros clientes en China, España, México y muy pronto en Brasil.', soon: 'Próximamente', active: 'Oficina activa' },
    contact: {
      eyebrow: '¡Hablemos!', title: '¿Tienes alguna pregunta o comentario?', subtitle: 'Háganoslo saber. Estaremos encantados de ayudarte.',
      emailUs: 'Envíanos un correo electrónico:', findUs: 'También puedes encontrarnos aquí:',
      formName: 'Nombre completo', formEmail: 'Correo electrónico', formPhone: 'Teléfono', formSubject: 'Asunto', formMessage: 'Mensaje',
      formSubmit: 'Enviar mensaje', formSending: 'Enviando...', formSuccess: '¡Gracias! Tu mensaje ha sido enviado. Te contactaremos pronto.', formError: 'Hubo un error al enviar el mensaje. Inténtalo de nuevo.',
      address: 'Dirección', phone: 'WhatsApp',
    },
    footer: { tagline: 'Asesoramiento fiscal, laboral, contable y jurídico para PYMES, autónomos y particulares.', quickLinks: 'Enlaces', servicesTitle: 'Servicios', contactTitle: 'Contacto', rights: 'Todos los derechos reservados', privacy: 'Términos de privacidad' },
    cta: { title: '¿Listo para dar el siguiente paso?', subtitle: 'Contacta con nuestro equipo y descubre cómo podemos ayudarte a hacer crecer tu negocio.', button: 'Contactar ahora' },
  },

  en: {
    nav: { home: 'Home', about: 'About Us', services: 'Services', contact: 'Contact', cta: 'Request consultation' },
    hero: {
      eyebrow: 'Law and advisory firm',
      title: 'Tax, labor, accounting and legal advisory',
      subtitle: 'For SMEs, self-employed workers and individuals. A team of highly qualified and experienced professionals serving the Chinese community in Spain.',
      ctaPrimary: 'View all services',
      ctaSecondary: 'Let\u2019s talk',
      scroll: 'Discover more',
    },
    about: {
      eyebrow: 'About us',
      title: 'Your trusted firm in Spain',
      p1: 'Zheng Da Abogados is a firm providing legal advisory services at both corporate and individual level, aimed mainly at the Chinese community in Spain.',
      p2: 'We are registered as a PAE point (entrepreneur advisory point within the CIRCE platform). We can set up companies electronically and register self-employed workers within a maximum of three days.',
      p3: 'Our lawyers and advisors will be delighted to help you with your matters, always from a relationship of transparency and mutual trust.',
      readMore: 'Read more',
      quote: '\u201cA company\u2019s growth is based on making the most of its resources\u201d',
      quoteAuthor: 'Libo Chen, director of Zheng Da Abogados',
      pageIntro: 'We offer advice both preventively and in the management of litigation across the different branches of law, always based on transparency and mutual trust. We cover the entire national territory of Spain.',
    },
    pillars: { eyebrow: 'Our', title: 'Service pillars' },
    services: {
      eyebrow: 'What we do',
      title: 'All the services you need, in one place',
      subtitle: 'A multidisciplinary team covering all the needs of your company and personal life.',
      all: 'View all services', detail: 'View detail', backToServices: 'Back to services', relatedTitle: 'Other services', keyPoints: 'What it includes',
    },
    location: { eyebrow: 'Our location', title: 'Zheng Da Abogados Fuenlabrada', directions: 'Get directions' },
    offices: { eyebrow: 'International presence', title: 'We are where you need us', subtitle: 'A firm with a global vocation: we support our clients in China, Spain, Mexico and very soon in Brazil.', soon: 'Coming soon', active: 'Active office' },
    contact: {
      eyebrow: 'Let\u2019s talk!', title: 'Do you have any questions or comments?', subtitle: 'Let us know. We\u2019ll be happy to help you.',
      emailUs: 'Send us an email:', findUs: 'You can also find us here:',
      formName: 'Full name', formEmail: 'Email', formPhone: 'Phone', formSubject: 'Subject', formMessage: 'Message',
      formSubmit: 'Send message', formSending: 'Sending...', formSuccess: 'Thank you! Your message has been sent. We\u2019ll contact you soon.', formError: 'There was an error sending the message. Please try again.',
      address: 'Address', phone: 'WhatsApp',
    },
    footer: { tagline: 'Tax, labor, accounting and legal advisory for SMEs, self-employed workers and individuals.', quickLinks: 'Links', servicesTitle: 'Services', contactTitle: 'Contact', rights: 'All rights reserved', privacy: 'Privacy terms' },
    cta: { title: 'Ready to take the next step?', subtitle: 'Contact our team and discover how we can help your business grow.', button: 'Contact now' },
  },

  zh: {
    nav: { home: '首页', about: '关于我们', services: '服务项目', contact: '联系我们', cta: '预约咨询' },
    hero: {
      eyebrow: '律师与顾问事务所',
      title: '税务、劳动、会计及法律咨询',
      subtitle: '面向中小企业、自雇人士和个人。一支高素质、经验丰富的专业团队，为西班牙华人社区提供服务。',
      ctaPrimary: '查看所有服务', ctaSecondary: '联系我们', scroll: '了解更多',
    },
    about: {
      eyebrow: '关于我们', title: '您在西班牙值得信赖的事务所',
      p1: 'Zheng Da 律师事务所为企业和个人提供法律咨询服务，主要面向西班牙的华人社区。',
      p2: '我们注册为 PAE 服务点（CIRCE 平台内的创业者咨询点）。我们可在线注册公司，并在最多三天内完成自雇人士注册。',
      p3: '我们的律师和顾问将竭诚为您处理各项事务，始终秉持透明和互信的原则。',
      readMore: '阅读更多', quote: '「企业的成长源于对其资源的最大化利用」', quoteAuthor: 'Libo Chen，Zheng Da 律师事务所所长',
      pageIntro: '我们在各法律领域提供预防性咨询和诉讼指导，始终以透明和互信为基础。我们的服务覆盖西班牙全国各地。',
    },
    pillars: { eyebrow: '我们的', title: '服务支柱' },
    services: {
      eyebrow: '我们做什么', title: '您所需的所有服务，一站式解决', subtitle: '多学科团队，满足您企业和个人生活的所有需求。',
      all: '查看所有服务', detail: '查看详情', backToServices: '返回服务列表', relatedTitle: '其他服务', keyPoints: '服务内容',
    },
    location: { eyebrow: '我们的位置', title: 'Zheng Da 律师事务所 Fuenlabrada', directions: '如何到达' },
    offices: { eyebrow: '国际业务网络', title: '哪里需要我们，我们就在哪里', subtitle: '一家具有全球视野的律师事务所：我们为中国、西班牙、墨西哥的客户提供服务，巴西业务即将开展。', soon: '即将开业', active: '现营业务点' },
    contact: {
      eyebrow: '联系我们！', title: '您有任何问题或建议吗？', subtitle: '请告诉我们。我们很乐意为您提供帮助。',
      emailUs: '给我们发送电子邮件：', findUs: '您也可以在这里找到我们：',
      formName: '全名', formEmail: '电子邮箱', formPhone: '电话', formSubject: '主题', formMessage: '留言',
      formSubmit: '发送留言', formSending: '发送中...', formSuccess: '谢谢！您的留言已发送。我们会尽快与您联系。', formError: '发送留言时出错，请重试。',
      address: '地址', phone: 'WhatsApp',
    },
    footer: { tagline: '为中小企业、自雇人士和个人提供税务、劳动、会计及法律咨询。', quickLinks: '快速链接', servicesTitle: '服务项目', contactTitle: '联系方式', rights: '版权所有', privacy: '隐私条款' },
    cta: { title: '准备好迈出下一步了吗？', subtitle: '联系我们的团队，了解我们如何帮助您的企业发展壮大。', button: '立即联系' },
  },

  pt: {
    nav: { home: 'Início', about: 'Sobre Nós', services: 'Serviços', contact: 'Contato', cta: 'Solicitar consulta' },
    hero: {
      eyebrow: 'Escritório de advocacia e assessoria',
      title: 'Assessoria fiscal, trabalhista, contábil e jurídica',
      subtitle: 'Voltado para PMEs, autônomos e pessoas físicas. Uma equipe de profissionais altamente qualificados e experientes a serviço da comunidade chinesa na Espanha.',
      ctaPrimary: 'Ver todos os serviços', ctaSecondary: 'Vamos conversar', scroll: 'Descubra mais',
    },
    about: {
      eyebrow: 'Sobre nós', title: 'Seu escritório de confiança na Espanha',
      p1: 'A Zheng Da Abogados é um escritório que presta serviços de assessoria jurídica em nível empresarial e particular, voltado principalmente para a comunidade chinesa na Espanha.',
      p2: 'Estamos registrados como ponto PAE (ponto de assessoria ao empreendedor dentro da plataforma CIRCE). Podemos constituir empresas de forma eletrônica e registrar autônomos em no máximo três dias.',
      p3: 'Nossos advogados e assessores terão prazer em ajudá-lo em seus assuntos, sempre com base em uma relação de transparência e confiança mútua.',
      readMore: 'Ler mais', quote: '\u201cO crescimento de uma empresa baseia-se no aproveitamento máximo de seus recursos\u201d', quoteAuthor: 'Libo Chen, diretor da Zheng Da Abogados',
      pageIntro: 'Oferecemos assessoria tanto em nível preventivo quanto na condução de processos contenciosos nos diferentes ramos do direito, sempre com base em transparência e confiança mútua. Atendemos todo o território nacional da Espanha.',
    },
    pillars: { eyebrow: 'Nossos', title: 'Pilares de serviço' },
    services: {
      eyebrow: 'O que fazemos', title: 'Todos os serviços de que você precisa, em um só lugar', subtitle: 'Uma equipe multidisciplinar que cobre todas as necessidades da sua empresa e da sua vida pessoal.',
      all: 'Ver todos os serviços', detail: 'Ver detalhes', backToServices: 'Voltar aos serviços', relatedTitle: 'Outros serviços', keyPoints: 'O que inclui',
    },
    location: { eyebrow: 'Nossa localização', title: 'Zheng Da Abogados Fuenlabrada', directions: 'Como chegar' },
    offices: { eyebrow: 'Presença internacional', title: 'Estamos onde você precisa', subtitle: 'Um escritório com vocação global: acompanhamos nossos clientes na China, Espanha, México e, em breve, no Brasil.', soon: 'Em breve', active: 'Escritório ativo' },
    contact: {
      eyebrow: 'Vamos conversar!', title: 'Tem alguma pergunta ou comentário?', subtitle: 'Conte para a gente. Teremos prazer em ajudá-lo.',
      emailUs: 'Envie-nos um e-mail:', findUs: 'Você também pode nos encontrar aqui:',
      formName: 'Nome completo', formEmail: 'E-mail', formPhone: 'Telefone', formSubject: 'Assunto', formMessage: 'Mensagem',
      formSubmit: 'Enviar mensagem', formSending: 'Enviando...', formSuccess: 'Obrigado! Sua mensagem foi enviada. Entraremos em contato em breve.', formError: 'Ocorreu um erro ao enviar a mensagem. Tente novamente.',
      address: 'Endereço', phone: 'WhatsApp',
    },
    footer: { tagline: 'Assessoria fiscal, trabalhista, contábil e jurídica para PMEs, autônomos e particulares.', quickLinks: 'Links', servicesTitle: 'Serviços', contactTitle: 'Contato', rights: 'Todos os direitos reservados', privacy: 'Termos de privacidade' },
    cta: { title: 'Pronto para dar o próximo passo?', subtitle: 'Entre em contato com nossa equipe e descubra como podemos ajudar sua empresa a crescer.', button: 'Entrar em contato' },
  },
};
